import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUser } from "../Redux/Actions/UserActions";
import { logoutSession } from "../utils/restAPI";
import { getAuthTokens } from "../utils/cookieUtils";
import { useWebSocket } from "./useWebSocket";

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { disconnect } = useWebSocket();

  return async () => {
    const localUser = getAuthTokens();

    if (localUser?.refreshToken) {
      await logoutSession(localUser.refreshToken);
    }

    dispatch(removeUser());
    disconnect();
    navigate("/login");
  };
};
